export enum LayoutTypes {
  LAYOUT_HORIZONTAL = 'horizontal',
}

export enum TopbarTheme {
  TOPBAR_THEME_LIGHT = 'light',
  TOPBAR_THEME_DARK = 'dark',
}
